












































import {
  Component,
  Vue,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { Getter, Action, Mutation } from 'vuex-class';

@Component({
  components: {
  },
})
export default class Connectivity extends Vue {
  @Getter private hasPermission: any;

  private connectivityMenu: object[] = [
    { id: 1, title: 'Sigfox Credentials', name: 'sigfoxCredentials' },
    { id: 2, title: 'LoRa Settings', name: 'loraSettings' },
    { id: 3, title: 'IoT Endpoint', name: 'iotEndpoint', permissions: 'administration:view' },
    { id: 4, title: 'SIM Cards', name: 'sims' },
  ];
}

